import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import useGetResourcesFormItems from './use-get-resources-form-items'

import ResourcesCrud from '../../components/resources-crud'

export default function Resources({
  history,
  match: {
    params: { resource }
  }
}: RouteComponentProps<{ resource: string }>) {
  const resourceComponents = useGetResourcesFormItems({ resource })

  if (!resourceComponents) {
    history.push('/')
    return null
  }

  return (
    <ResourcesCrud
      dataColumns={resourceComponents.dataColumns}
      dataSource={resourceComponents.dataSource}
      drawerForm={resourceComponents.drawerForm}
      getPage={resourceComponents.getPage}
      header={resourceComponents.header}
      initialValues={resourceComponents.initialValues}
      isLoading={resourceComponents.isLoading}
      onSubmit={resourceComponents.onSubmit}
      pagination={resourceComponents.pagination}
      title={resourceComponents.title}
      validationSchema={resourceComponents.validationSchema}
      width={resourceComponents.width}
    />
  )
}
